"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AuthenticationService_model_1 = require("../authentication-service/AuthenticationService.model");
class ConfigUserProvider {
    constructor(config) {
        if (!config.response_type) {
            config.response_type = "code";
        }
        if (!config.scope) {
            config.scope = "email openid profile mobile";
        }
        if (config.authority && config.authority.charAt(config.authority.length - 1) === '/') {
            config.authority = config.authority.slice(0, config.authority.length - 1);
        }
        this.config = config;
        this.userManager = new AuthenticationService_model_1.OidcManager(this.config);
    }
    setConfig(config) {
        this.config = Object.assign(Object.assign({}, this.config), config);
    }
    getConfig() {
        return this.config;
    }
    getUserManager() {
        return this.userManager;
    }
}
exports.default = ConfigUserProvider;
